<template>
    <div class="modal-overlay" @click="closeModal">
        <!-- 弹窗内容（阻止冒泡） -->
        <div class="modal-content" @click.stop>
            <div class="modal-title">提示</div>
            <div class="modal-body">
                <div class="modal-text">
                    当前次数不足，请至会员中心查看具体权益
                </div>
            </div>
            <div class="modal-confirm-div">
                <div class="modal-confirm-btn" @click="closeModal">返回</div>
                <div class="modal-confirm-btn-ff" @click="goMemberCenter">立即前往</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'lackModal', // 重命名组件，避免与节点语义混淆
    props: {
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        goMemberCenter() {
            this.$emit('closeModal');
            wx.miniProgram.navigateTo({
                //拼接url
                url: "/pages/mine/vipCenter",
            });
        },
        closeModal() {
            this.$emit('closeModal');
        },
    }
}
</script>

<style lang="less" scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

/* 弹窗内容 */
.modal-content {
    width: 80vw;
    /* height: 58.666vw; */
    border-radius: 3.2vw;
    background-color: #ffffff;
}

.modal-title {
    line-height: 6.2666vw;
    color: #666666;
    font-weight: 500;
    font-size: 4.2666vw;
    text-align: center;
    padding: 5.333vw 0 4.2666vw 0;
}

.modal-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.modal-text {
    width: 67.2vw;
    color: #666666;
    font-weight: 400;
    font-size: 3.2vw;
    line-height: 4.8vw;
    margin-top: 1.0666vw;
    text-align: center;
}

.messageUrl {
    word-break: break-all;
    /* 强制在任意字符间换行（包括英文/数字） */
    overflow-wrap: break-word;
    /* 更智能的换行（优先在空格/连字符处断） */
    white-space: normal;
}

.modal-confirm-div {
    display: flex;
    justify-content: center;
    margin-top: 6.5333vw;
    margin-bottom: 5.333vw;
}

.modal-confirm-btn {
    width: 29.333vw;
    height: 10.666vw;
    border-radius: 2.1333vw;
    background-color: #ebebed;
    line-height: 10.666vw;
    opacity: 0.8;
    color: #666666;
    font-weight: 500;
    font-size: 3.2vw;
    text-align: center;
    margin-right: 5.333vw;
}

.modal-confirm-btn-ff {
    width: 29.333vw;
    height: 10.666vw;
    border-radius: 2.1333vw;
    background: linear-gradient(148.76deg,
            rgba(47, 255, 181, 1) 0%,
            rgba(30, 137, 255, 1) 100%);
    line-height: 10.666vw;
    color: #ffffff;
    font-weight: 500;
    font-size: 3.2vw;
    text-align: center;
}

.videoDivTime {
    position: absolute;
    bottom: 5.0666vw;
    left: 10vw;
    height: 7.8666vw;
    color: #ffffff;
    font-weight: 500;
    font-size: 5.333vw;
    text-align: left;
}
</style>